// MenuItemsPage.jsx
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

// import { MenuItem as MenuItemEntity } from "@/entities/MenuItem";
// import { Module } from "@/entities/Module";
// import { Package } from "@/entities/Package";
// import { Role } from "@/entities/Role";
// import { useToast } from "@/components/ui/use-toast";
// import useAppLevelAuth from "@/hooks/useAppLevelAuth";

import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  FormLabel,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
  IconButton,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "../../Style/MenuItemsPage.scss";
import authHeader from "../../Auth/authHeader";
import { GetMenuItems } from "../../GetData/MenuItems";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { GetSystemRoles } from "../../GetData/SystemRoles";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import { getMenuItemByID } from "../../GetData/MenuItemByID";
import jwtDecode from "jwt-decode";

function canOpenMenuItemsPage() {
  try {
    const claims = jwtDecode(localStorage.getItem("token") || "");
    const role = claims.role ?? claims["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    return (!claims.exp || claims.exp * 1000 > Date.now()) &&
      (Array.isArray(role) ? role : [role])
        .some(value => String(value || "").toLowerCase() === "acctree");
  } catch {
    return false;
  }
}

export default function MenuItemsPage() {
  const history = useHistory();

  if (!canOpenMenuItemsPage()) {
    return (
      <Box sx={{ minHeight: "60vh", display: "grid", placeItems: "center", p: 2 }}>
        <Card sx={{ width: "100%", maxWidth: 480, borderRadius: 3, textAlign: "center" }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" component="h1" gutterBottom>Qasja nuk lejohet</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Nuk keni leje për të hapur Listën e Menuve.
            </Typography>
            <Button variant="contained" onClick={() => history.replace("/dashboard")}>Kthehu te paneli</Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return <MenuItemsPageContent />;
}

function MenuItemsPageContent() {
  //   const { isLoggedIn } = useAppLevelAuth();
  //   const { toast } = useToast();
  const toast = null;
  const history = useHistory();
  // const [searchParams] = useSearchParams();
  const location = useLocation();

  const headers = authHeader();
  const query = new URLSearchParams(location.search);
  const mode = query.get("mode") || "list";
  // const mode = searchParams.get("mode") || "list";
  // const mode = "views";
  const itemId = query.get("id");
  // const itemId = 1;

  const [menuItems, setMenuItems] = useState([]);
  const [parentMenuItems, setParentMenuItems] = useState([]);
  const [modules, setModules] = useState([]);
  const [packages, setPackages] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedMenus, setExpandedMenus] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    icon: "",
    path: "",
    componentKey: "",
    projectType: "Acctree",
    isParentMenu: false,
    parentId: "",
    orderNr: 0,
    isGlobal: false,
    isActive: true,
    moduleIds: [],
    packageIds: [],
    rolePermissions: [],
  });

  const isViewMode = mode === "view";

  const buildMenuItemsUrl = (params) => {
    const base = "/configuration/menuItems";
    if (!params) return base;
    const query = new URLSearchParams(params).toString();
    return `${base}?${query}`;
  };

  const returnToList = (params) => {
    const base = "/configuration/menuItems";
    if (!params) return base;
    const query = new URLSearchParams(params).toString();
    return `${base}?${query}`;
  };

  //   useEffect(() => {
  //     if (!isLoggedIn) return;
  //     loadData();
  //   }, [isLoggedIn]);

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && itemId) {
      loadMenuItem(itemId);
    } else if (mode === "add") {
      resetForm();
    }
  }, [mode, itemId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [menuData, moduleData, packageData, roleData] = await Promise.all([
        // MenuItemEntity.list("orderNr:asc"),
        // Module.list("createdAt:desc"),
        // Package.list("createdAt:desc"),
        // Role.list("createdAt:desc"),
      ]);

      setMenuItems(menuData || []);
      setModules(moduleData || []);
      setPackages(packageData || []);
      setRoles(roleData || []);
    } catch (error) {
      console.error("Error loading data:", error);
      toast({
        title: "Error",
        description: "Failed to load data",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const loadMenuItem = async (id) => {
    try {
      const item = await getMenuItemByID(headers, id);

      console.log(item);

      // const item = [];
      setFormData({
        title: item.Title || "",
        icon: item.Icon || "",
        path: item.Path || "",
        componentKey: item.ComponentKey || "",
        projectType: item.ProjectType || "Acctree",
        isParentMenu: item.IsParentMenu || false,
        parentId: item.ParentID || "",
        orderNr: item.OrderNo || 0,
        isGlobal: item.IsGlobal || false,
        isActive: item.IsActive !== undefined ? item.IsActive : true,
        moduleIds: normalizeNumberList(
          item.ModuleIds ?? item.ModuleIDs ?? item.moduleIds ?? item.moduleIDs ?? []
        ),
        packageIds: normalizeNumberList(
          item.PackageIDs ?? item.PackageIds ?? item.packageIDs ?? item.packageIds ?? []
        ),
        rolePermissions: normalizeRolePermissions(
          item.RolePermissions ?? item.rolePermissions ?? []
        ),
      });
    } catch (error) {
      // toast({
      //   title: "Error",
      //   description: "Failed to load menu item",
      //   variant: "destructive",
      // });
      errorAlert("Failed to load menu item");
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      icon: "",
      path: "",
      componentKey: "",
      projectType: "Acctree",
      isParentMenu: false,
      parentId: "",
      orderNr: 0,
      isGlobal: false,
      isActive: true,
      moduleIds: [],
      packageIds: [],
      rolePermissions: [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const normalizedPath = (formData.path || "").trim();
    const normalizedComponentKey = (formData.componentKey || "").trim();
    const isParentMenu = !!formData.isParentMenu;

    const payload = {
      title: formData.title,
      icon: formData.icon,
      path: isParentMenu || normalizedPath === "" ? null : normalizedPath,
      componentKey:
        isParentMenu || normalizedComponentKey === ""
          ? null
          : normalizedComponentKey,
      projectType: formData.projectType,
      isParentMenu,
      parentId:
        isParentMenu || !formData.parentId ? null : Number(formData.parentId),
      orderNr: Number(formData.orderNr),
      isGlobal: formData.isGlobal,
      isActive: formData.isActive,
      // packageId: Number(formData.packageId),
      PackageIDs: formData.packageIds.map((x) => Number(x)),
      moduleIds: formData.moduleIds.map((x) => Number(x)),
      rolePermissions: (formData.rolePermissions || []).map((rp) => ({
        roleId: Number(rp.roleId),
        canView: rp.canView,
        canAdd: rp.canAdd,
        canEdit: rp.canEdit,
        canDelete: rp.canDelete,
      })),
    };

    try {
      if (mode === "edit" && itemId) {
        await axios.put(ApiLink.API_URL + `MenuItem/update/${itemId}`, payload, {
          headers,
        });
        handleSuccess("Menu item updated successfully");
        await loadAll();
        history.push(buildMenuItemsUrl());
      } else {
        // await MenuItemEntity.create(formData);
        await axios.post(ApiLink.API_URL + "MenuItem/insert", payload, {
          headers,
        });
        // toast({
        //   title: "Success",
        //   description: "Menu item created successfully",
        // });
        handleSuccess("Menu item created successfully");
        await loadAll();
        history.push(buildMenuItemsUrl());
        // loadAll();
        // setFormData({
        //   title: "",
        //   icon: "",
        //   path: "",
        //   componentKey: "",
        //   parentId: "",
        //   orderNr: 0,
        //   isGlobal: false,
        //   isActive: true,
        //   moduleIds: [],
        //   packageIds: [],
        //   rolePermissions: [],
        // });
      }
      // console.log(formData);

      //   navigate(buildMenuItemsUrl());
      // loadData();
    } catch (error) {
      // toast({
      //   title: "Error",
      //   description: "Failed to save menu item",
      //   variant: "destructive",
      // });
      errorAlert("error");
      console.log(formData);
    }
  };

  const handleMenuKindChange = (selectedValue) => {
    const shouldBeParent = selectedValue === "menu";

    setFormData((prev) => ({
      ...prev,
      isParentMenu: shouldBeParent,
      path: shouldBeParent ? "" : prev.path,
      componentKey: shouldBeParent ? "" : prev.componentKey,
      parentId: shouldBeParent ? "" : prev.parentId,
    }));

    if (shouldBeParent) {
      setParentField(null);
    }
  };

  const openDeleteDialog = (item) => {
    setItemToDelete(item);
    setDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      await axios.delete(
        ApiLink.API_URL + `MenuItem/delete/${itemToDelete.MenuID}`,
        { headers }
      );

      handleSuccess("Menu item deleted successfully");
      closeDeleteDialog();
      await loadAll();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error || "Failed to delete menu item";
      errorAlert(errorMessage);
    }
  };

  const handleRoleToggle = (roleId, checked) => {
    if (checked) {
      setFormData((prev) => ({
        ...prev,
        rolePermissions: [
          ...(prev.rolePermissions || []),
          {
            roleId,
            canView: false,
            canAdd: false,
            canEdit: false,
            canDelete: false,
          },
        ],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        rolePermissions: (prev.rolePermissions || []).filter(
          (rp) => String(rp.roleId) !== String(roleId)
        ),
      }));
    }
  };

  const handlePermissionChange = (roleId, permission, checked) => {
    setFormData((prev) => ({
      ...prev,
      rolePermissions: (prev.rolePermissions || []).map((rp) =>
        String(rp.roleId) === String(roleId)
          ? { ...rp, [permission]: checked }
          : rp
      ),
    }));
  };

  // const handleModuleToggle = (moduleId, checked) => {
  //   if (checked) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       moduleIds: [...(prev.moduleIds || []), moduleId],
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       moduleIds: (prev.moduleIds || []).filter((id) => id !== moduleId),
  //     }));
  //   }
  // };
  const handleModuleToggle = (moduleId, checked) => {
    setFormData((prev) => {
      const current = prev.moduleIds || [];

      const updated = checked
        ? [...current, moduleId]
        : current.filter((id) => id !== moduleId);
      return {
        ...prev,
        moduleIds: updated,
      };
    });
  };

  const handlePackToggle = (packID, checked) => {
    setFormData((prev) => {
      const current = prev.packageIds || [];

      const updated = checked
        ? [...current, packID]
        : current.filter((id) => id !== packID);
      return {
        ...prev,
        packageIds: updated,
      };
    });
  };

  const loadAll = async () => {
    try {
      const [menuData, packageData, moduleData, roleData] = await Promise.all([
        GetMenuItems(headers),
        getSystemPackage(headers),
        getSystemModules(headers), // thirrja jote e tretë
        GetSystemRoles(headers), // thirrja jote e katërt
      ]);

      if (menuData) setMenuItems(menuData);
      if (packageData) setPackages(packageData);
      if (moduleData) setModules(moduleData);
      if (roleData) setRoles(roleData);
    } catch (error) {
      errorAlert("Gabim gjatë ngarkimit:");
    }
  };
  useEffect(() => {
    // const loadAll = async () => {
    //   try {
    //     const [menuData, packageData, moduleData, roleData] = await Promise.all(
    //       [
    //         GetMenuItems(headers),
    //         getSystemPackage(headers),
    //         getSystemModules(headers), // thirrja jote e tretë
    //         GetSystemRoles(headers), // thirrja jote e katërt
    //       ]
    //     );

    //     if (menuData) setMenuItems(menuData);
    //     if (packageData) setPackages(packageData);
    //     if (moduleData) setModules(moduleData);
    //     if (roleData) setRoles(roleData);
    //   } catch (error) {
    //     errorAlert("Gabim gjatë ngarkimit:");
    //   }
    // };

    loadAll();
  }, []);

  useEffect(() => {
    const loadParentMenus = async () => {
      try {
        const data = await GetMenuItems(headers, {
          isParentMenu: true,
          projectType: formData.projectType,
        });

        setParentMenuItems(data || []);
      } catch (error) {
        setParentMenuItems([]);
      }
    };

    loadParentMenus();
  }, [formData.projectType]);

  const normalizeParentId = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return null;
    return num;
  };

  const sortMenus = (left, right) => {
    const leftOrder = Number(left?.OrderNo ?? 0);
    const rightOrder = Number(right?.OrderNo ?? 0);
    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }
    return String(left?.Title || "").localeCompare(String(right?.Title || ""));
  };

  const menuTree = React.useMemo(() => {
    const items = Array.isArray(menuItems) ? [...menuItems] : [];
    const ids = new Set(items.map((item) => Number(item?.MenuID)).filter((x) => Number.isFinite(x)));
    const childrenByParent = new Map();

    items.forEach((item) => {
      const rawParentId = normalizeParentId(item?.ParentID);
      const parentId = rawParentId && ids.has(rawParentId) ? rawParentId : null;
      const bucket = childrenByParent.get(parentId) || [];
      bucket.push(item);
      childrenByParent.set(parentId, bucket);
    });

    const buildBranch = (parentId, depth) => {
      const nodes = (childrenByParent.get(parentId) || []).sort(sortMenus);
      return nodes.map((node) => {
        const menuId = Number(node?.MenuID);
        const children = buildBranch(Number.isFinite(menuId) ? menuId : null, depth + 1);
        return {
          ...node,
          _depth: depth,
          _children: children,
        };
      });
    };

    return buildBranch(null, 0);
  }, [menuItems]);

  const searchValue = (searchTerm || "").trim().toLowerCase();

  const filteredTree = React.useMemo(() => {
    if (!searchValue) {
      return menuTree;
    }

    const filterBranch = (nodes) => {
      return nodes
        .map((node) => {
          const children = filterBranch(node._children || []);
          const title = String(node?.Title || "").toLowerCase();
          const path = String(node?.Path || "").toLowerCase();
          const matches = title.includes(searchValue) || path.includes(searchValue);

          if (!matches && children.length === 0) {
            return null;
          }

          return {
            ...node,
            _children: children,
          };
        })
        .filter(Boolean);
    };

    return filterBranch(menuTree);
  }, [menuTree, searchValue]);

  const visibleMenuRows = React.useMemo(() => {
    const rows = [];

    const walk = (nodes) => {
      (nodes || []).forEach((node) => {
        rows.push(node);
        const hasChildren = (node._children || []).length > 0;
        if (hasChildren && expandedMenus[node.MenuID]) {
          walk(node._children);
        }
      });
    };

    walk(filteredTree);
    return rows;
  }, [filteredTree, expandedMenus]);

  const toggleRowExpand = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const normalizeNumberList = (list) => {
    if (!Array.isArray(list)) return [];
    return list
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value));
  };

  const normalizeRolePermissions = (list) => {
    if (!Array.isArray(list)) return [];

    return list
      .map((rp) => {
        const roleId = rp?.roleId ?? rp?.RoleId;
        if (roleId === undefined || roleId === null || roleId === "") return null;

        return {
          roleId,
          canView: !!(rp?.canView ?? rp?.CanView),
          canAdd: !!(rp?.canAdd ?? rp?.CanAdd),
          canEdit: !!(rp?.canEdit ?? rp?.CanEdit),
          canDelete: !!(rp?.canDelete ?? rp?.CanDelete),
        };
      })
      .filter(Boolean);
  };

  const inheritParentAssignments = async (parentMenuId) => {
    try {
      const parentMenu = await getMenuItemByID(headers, parentMenuId);

      setFormData((prev) => ({
        ...prev,
        packageIds: normalizeNumberList(
          parentMenu?.PackageIDs ??
            parentMenu?.packageIDs ??
            parentMenu?.packageIds ??
            []
        ),
        moduleIds: normalizeNumberList(
          parentMenu?.ModuleIds ?? parentMenu?.moduleIds ?? []
        ),
        rolePermissions: normalizeRolePermissions(
          parentMenu?.RolePermissions ?? parentMenu?.rolePermissions ?? []
        ),
      }));
    } catch (error) {
      errorAlert("Nuk u be trashegimia automatike nga menuja prind.");
    }
  };

  //Pjesa per select input field menu parents
  const [parentField, setParentField] = useState(null);
  const handleAutocompleteChangeParent = async (event, value) => {
    if (value && value.MenuID) {
      setFormData((prev) => ({
        ...prev,
        parentId: value.MenuID,
      }));
      setParentField(value);

      // Ne regjistrim te nenmenus, trashego automatikisht paketat/modulet/rolet nga menuja prind.
      if (mode === "add" && !formData.isParentMenu) {
        await inheritParentAssignments(value.MenuID);
      }
    } else {
      // Në rast se vlera është pastruar
      setFormData((prev) => ({
        ...prev,
        parentId: "",
      }));
      setParentField(null);
    }
  };

  const parentMenuOptions = (parentMenuItems || []).filter((item) => {
    const isCurrentItem = itemId && Number(item?.MenuID) === Number(itemId);
    return !isCurrentItem;
  });

  const defaultPropsParent = {
    options: parentMenuOptions,
    getOptionLabel: (option) => `${option.Title} - ${option.OrderNo}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.Title}
            <br />
            Numri rendor -{option.OrderNo}
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field menu package
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackage = (event, value) => {
    if (value && value.PackageID) {
      setFormData({
        ...formData,
        packageId: value ? value.PackageID : "",
      });
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setFormData({
        ...formData,
        PackageID: "",
      });
      setPackageField(null);
    }
  };

  const defaultPropsPackage = {
    options: packages,
    getOptionLabel: (option) =>
      `${option.PackageName} - ${option.YearlyPrice}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
            Cmimi vjetor -{option.YearlyPrice}
          </span>
        </li>
      </>
    ),
  };

  //   if (!isLoggedIn) return null;

  if (!loading && mode === "list") {
    return (
      <div className="menu-items-page">
        <div className="mi-stack mi-stack--lg">
          <div className="mi-loading-card pulse-loader" />
          <div className="mi-loading-card mi-loading-card--tall pulse-loader" />
        </div>
      </div>
    );
  }

  // ADD / EDIT / VIEW FORM
  if (mode === "add" || mode === "edit" || mode === "view") {
    return (
      <div className="menu-items-page">
        <div className="mi-stack mi-stack--lg">
          <div className="mi-header mi-header--between">
            <div>
              <h1 className="mi-title">
                {mode === "add"
                  ? "Add Menu Item"
                  : mode === "edit"
                  ? "Edit Menu Item"
                  : "View Menu Item"}
              </h1>
              <p className="mi-subtitle">
                {mode === "add"
                  ? "Create a new menu item"
                  : mode === "edit"
                  ? "Update menu item details"
                  : "View menu item details"}
              </p>
            </div>
            <Button
              variant="outlined"
              onClick={() => {
                loadAll(); // funksioni yt shtesë që duhet të ekzekutohet
                history.push("/configuration/menuItems"); // navigimi
              }}
              className="mi-btn-back"
            >
              <ArrowBackIcon className="mi-icon-left" />
              Back to List
            </Button>
          </div>

          <form onSubmit={handleSubmit}>
            <Card className="mi-card">
              <CardContent className="mi-card-content mi-card-content--lg">
                <div className="mi-section mi-priority-section">
                  <div className="mi-priority-header">
                    <h3 className="mi-section-title mi-section-title--no-border">
                      Konfigurimi Kryesor
                    </h3>
                    <p className="mi-priority-subtitle">
                      Se pari zgjedh projektin dhe llojin e menus. Keto dy
                      zgjedhje percaktojne sjelljen e formes.
                    </p>
                    <div className="mi-priority-meta">
                      <span className="mi-chip mi-chip--project">
                        Projekti: {formData.projectType}
                      </span>
                      <span className="mi-chip mi-chip--type">
                        Lloji: {formData.isParentMenu ? "Menu Prind" : "Nenmenu"}
                      </span>
                    </div>
                  </div>

                  <div className="mi-grid mi-grid--2cols">
                    <div className="mi-priority-card">
                      <FormControl fullWidth size="small" className="mi-field-control">
                        <FormLabel className="mi-field-label">Project Type</FormLabel>
                        <Select
                          className="mi-input"
                          value={formData.projectType}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              projectType: e.target.value,
                            })
                          }
                          disabled={isViewMode}
                        >
                          <MenuItem value="Acctree">Acctree</MenuItem>
                          <MenuItem value="Doktorri">Doktorri</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div className="mi-priority-card">
                      <FormControl fullWidth size="small" className="mi-field-control">
                        <FormLabel className="mi-field-label">Lloji i menus</FormLabel>
                        <RadioGroup
                          row
                          value={formData.isParentMenu ? "menu" : "submenu"}
                          onChange={(e) => handleMenuKindChange(e.target.value)}
                        >
                          <FormControlLabel
                            value="menu"
                            control={<Radio />}
                            label="Menu"
                            disabled={isViewMode}
                          />
                          <FormControlLabel
                            value="submenu"
                            control={<Radio />}
                            label="Nenmenu"
                            disabled={isViewMode}
                          />
                        </RadioGroup>
                        <Typography className="mi-priority-help">
                          {formData.isParentMenu
                            ? "Menu prind: Path, Component Key dhe Parent Menu jane te fikura automatikisht."
                            : "Nenmenu: te gjitha fushat jane aktive dhe Parent Menu duhet zgjedhur."}
                        </Typography>
                      </FormControl>
                    </div>
                  </div>
                </div>

                {/* Basic Information */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Detajet Kryesore</h3>
                  <div className="mi-grid mi-grid--2cols">
                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Title *</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.title}
                        onChange={(e) =>
                          setFormData({ ...formData, title: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="Enter menu title"
                        required
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Titulli"
                      variant="filled"
                      value={formData.title}
                      onChange={(e) =>
                        setFormData({ ...formData, title: e.target.value })
                      }
                      disabled={isViewMode}
                      placeholder="Shkruaj titullin e menus"
                      required
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Icon</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.icon}
                        onChange={(e) =>
                          setFormData({ ...formData, icon: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="e.g., Home, Settings"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Icon"
                      variant="filled" // ose "filled" nëse e do në atë stil
                      value={formData.icon}
                      onChange={(e) =>
                        setFormData({ ...formData, icon: e.target.value })
                      }
                      disabled={isViewMode}
                      placeholder="p.sh. bi bi-speedometer"
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Path *</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.path}
                        onChange={(e) =>
                          setFormData({ ...formData, path: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="/path/to/page"
                        required
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Path"
                      variant="filled"
                      value={formData.path}
                      onChange={(e) =>
                        setFormData({ ...formData, path: e.target.value })
                      }
                      disabled={isViewMode || formData.isParentMenu}
                      placeholder={
                        formData.isParentMenu
                          ? "Path nuk kerkohet per menu prind"
                          : "/path/to/page"
                      }
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Component Key
                      </FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.componentKey}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            componentKey: e.target.value,
                          })
                        }
                        disabled={isViewMode}
                        placeholder="ComponentName"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Component Key"
                      variant="filled"
                      value={formData.componentKey}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          componentKey: e.target.value,
                        })
                      }
                      disabled={isViewMode || formData.isParentMenu}
                      placeholder={
                        formData.isParentMenu
                          ? "Component Key nuk kerkohet per menu prind"
                          : "ComponentName"
                      }
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Parent Menu
                      </FormLabel>
                      <Select
                        className="mi-input"
                        value={formData.parentId}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            parentId: e.target.value,
                          })
                        }
                        disabled={isViewMode}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>None (Root Level)</em>
                        </MenuItem>
                        {(menuItems || []).map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.Title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl> */}
                    <Autocomplete
                      {...defaultPropsParent}
                      id="include-input-in-list"
                      includeInputInList
                      value={parentField}
                      onChange={handleAutocompleteChangeParent}
                      isOptionEqualToValue={(option, value) =>
                        option.MenuID === value.MenuID
                      } // Shto funksionin isOptionEqualToValue
                      disabled={isViewMode || formData.isParentMenu}
                      renderInput={(params) => (
                        <TextField
                          // style={{ width: "95%" }}
                          {...params}
                          label="Zgjedh menune kryesore"
                          variant="filled"
                          placeholder={
                            formData.isParentMenu
                              ? "Jo e nevojshme per menu prind"
                              : "Zgjedh menune prind"
                          }

                          // variant="filled"
                          //   onKeyPress={handleKeyPress}
                        />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: 4 * 48, // 48px është lartësia default e një opsioni
                        },
                      }}
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Order Number
                      </FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        type="number"
                        value={formData.orderNr}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            orderNr: parseInt(e.target.value, 10) || 0,
                          })
                        }
                        disabled={isViewMode}
                        placeholder="0"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Numri Rendor"
                      variant="filled"
                      type="number"
                      value={formData.orderNr}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          orderNr: parseInt(e.target.value, 10) || 0,
                        })
                      }
                      disabled={isViewMode}
                      placeholder="0"
                      className="mi-input"
                    />
                  </div>
                </div>

                {/* Status Flags */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Status</h3>
                  <p className="mi-section-subtitle">
                    Percakto nese menuja duhet te jete aktive dhe globale.
                  </p>
                  <div className="mi-status-row">
                    <FormControlLabel
                      className="mi-checkbox-row"
                      control={
                        <Checkbox
                          checked={formData.isGlobal}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isGlobal: e.target.checked,
                            })
                          }
                          disabled={isViewMode}
                        />
                      }
                      label="Menu Globale"
                    />
                    <FormControlLabel
                      className="mi-checkbox-row"
                      control={
                        <Checkbox
                          checked={formData.isActive}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isActive: e.target.checked,
                            })
                          }
                          disabled={isViewMode}
                        />
                      }
                      label="Aktive"
                    />
                  </div>
                </div>

                {/* Package Selection */}
                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Pakot e systemit</h3>
                  <Autocomplete
                    {...defaultPropsPackage}
                    id="include-input-in-list"
                    includeInputInList
                    value={packageField}
                    onChange={handleAutocompleteChangePackage}
                    isOptionEqualToValue={(option, value) =>
                      option.PackageID === value.PackageID
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="zgjedh pakon"
                        variant="filled"
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 4 * 48, 
                      },
                    }}
                  /> */}
                {/* <FormControl
                    fullWidth
                    size="small"
                    className="mi-field-control"
                  >
                    <FormLabel className="mi-field-label">
                      Select Package
                    </FormLabel>
                    <Select
                      className="mi-input"
                      value={formData.packageId}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          packageId: e.target.value,
                        })
                      }
                      disabled={isViewMode}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {(packages || []).map((pkg) => (
                        <MenuItem key={pkg.id} value={pkg.id}>
                          {pkg.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                {/* </div> */}

                <div className="mi-section">
                  <h3 className="mi-section-title">Pakot</h3>
                  <p className="mi-section-subtitle">
                    Pakot aktive: {(packages || []).length}
                  </p>

                  <div className="mi-modules-grid">
                    {(packages || []).map((pack) => {
                      const isChecked = (formData.packageIds || []).includes(
                        pack.PackageID
                      );

                      return (
                        <div
                          key={pack.PackageID}
                          className="mi-module-card"
                          onClick={() => {
                            handlePackToggle(pack.PackageID, !isChecked);
                          }}
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={(e) => {
                              e.stopPropagation(); // SHUMË E RËNDËSISHME! NDALON DY KLIKIME
                              handlePackToggle(
                                pack.PackageID,
                                e.target.checked
                              );
                            }}
                            disabled={isViewMode}
                          />

                          <span className="mi-module-label">
                            {pack.PackageName}
                          </span>
                        </div>
                      );
                    })}

                    {(packages || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë Pako</p>
                    )}
                  </div>
                </div>

                {/* Module Selection */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Modulet</h3>
                  <p className="mi-section-subtitle">
                    Modulet aktive: {(modules || []).length}
                  </p>

                  <div className="mi-modules-grid">
                    {(modules || []).map((module) => {
                      const isChecked = (formData.moduleIds || []).includes(
                        module.ModuleID
                      );

                      return (
                        <div
                          key={module.ModuleID}
                          className="mi-module-card"
                          onClick={() => {
                            handleModuleToggle(module.ModuleID, !isChecked);
                          }}
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={(e) => {
                              e.stopPropagation(); // SHUMË E RËNDËSISHME! NDALON DY KLIKIME
                              handleModuleToggle(
                                module.ModuleID,
                                e.target.checked
                              );
                            }}
                            disabled={isViewMode}
                          />

                          <span className="mi-module-label">
                            {module.ModuleName}
                          </span>
                        </div>
                      );
                    })}

                    {(modules || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë modul</p>
                    )}
                  </div>
                </div>

                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Modulet</h3>
                  <div className="mi-modules-grid">
                    {(modules || []).map((module) => (
                      <div key={module.ModuleID} className="mi-module-card">
                        <Checkbox
                          checked={(formData.moduleIds || []).includes(
                            module.ModuleID
                          )}
                          onChange={(e) =>
                            handleModuleToggle(module.ModuleID, e.target.checked)
                          }
                          disabled={isViewMode}
                        />
                        <span className="mi-module-label">{module.ModuleName}</span>
                      </div>
                    ))}
                    {(modules || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë mmodul</p>
                    )}
                  </div>
                </div> */}

                {/* Role Permissions */}
                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Rolet</h3>
                  <div className="mi-role-list">
                    {(roles || []).map((role) => {
                      const rolePermission = (
                        formData.rolePermissions || []
                      ).find((rp) => String(rp.roleId) === String(role.Id));
                      const isRoleSelected = !!rolePermission;

                      return (
                        <div key={role.id} className="mi-role-card">
                          <div className="mi-role-header">
                            <Checkbox
                              checked={isRoleSelected}
                              onChange={(e) =>
                                handleRoleToggle(role.Id, e.target.checked)
                              }
                              disabled={isViewMode}
                            />
                            <span className="mi-role-label">{role.Name}</span>
                          </div>

                          {isRoleSelected && (
                            <div className="mi-role-permissions-grid">
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canView || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canView",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can View"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canAdd || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canAdd",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Add"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canEdit || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canEdit",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Edit"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canDelete || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canDelete",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Delete"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {(roles || []).length === 0 && (
                      <p className="mi-empty-text">No roles available</p>
                    )}
                  </div>
                </div> */}

                <div className="mi-section">
                  <h3 className="mi-section-title">Rolet</h3>
                  <p className="mi-section-subtitle">
                    Konfiguro lejet sipas roleve: {(roles || []).length} role
                  </p>

                  <div className="mi-role-list">
                    {(roles || []).map((role) => {
                      const rolePermission = (
                        formData.rolePermissions || []
                      ).find((rp) => String(rp.roleId) === String(role.Id));
                      const isRoleSelected = !!rolePermission;

                      return (
                        <div key={role.Id} className="mi-role-card">
                          {/* Vetëm header është klikues */}
                          <div
                            className="mi-role-header"
                            onClick={() =>
                              !isViewMode &&
                              handleRoleToggle(role.Id, !isRoleSelected)
                            }
                          >
                            <Checkbox
                              checked={isRoleSelected}
                              onChange={(e) =>
                                handleRoleToggle(role.Id, e.target.checked)
                              }
                              disabled={isViewMode}
                              onClick={(e) => e.stopPropagation()} // E RËNDËSISHME!
                            />

                            <span className="mi-role-label">{role.Name}</span>
                          </div>

                          {/* Permission checkbox-et nuk kanë onClick të kartës */}
                          {isRoleSelected && (
                            <div className="mi-role-permissions-grid">
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canView || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canView",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Lejo Shikim"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canAdd || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canAdd",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Lejo Shtim"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canEdit || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canEdit",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Lejo Editim"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canDelete || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canDelete",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Lejo Fshirje"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}

                    {(roles || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka role ne dispozicion</p>
                    )}
                  </div>
                </div>

                {/* Form Actions */}
                {!isViewMode && (
                  <div className="mi-form-actions">
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={() => history.push(buildMenuItemsUrl())}
                    >
                      Anulo
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      startIcon={<SaveIcon />}
                    >
                      {mode === "edit" ? "Ruaj Ndryshimet" : "Krijo Menu"}
                    </Button>
                  </div>
                )}
              </CardContent>
            </Card>
          </form>
        </div>
      </div>
    );
  }

  // LIST MODE
  return (
    <div className="menu-items-page">
      <div className="mi-stack mi-stack--lg">
        <div className="mi-header mi-header--responsive">
          <div>
            <h1 className="mi-title">Menu Items</h1>
            <p className="mi-subtitle">
              Manage your application menu structure
            </p>
          </div>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => history.push(buildMenuItemsUrl({ mode: "add" }))}
          >
            Add Menu Item
          </Button>
        </div>

        <Card className="mi-card">
          <CardContent>
            <div className="mi-search-wrapper">
              <FormControl fullWidth size="small" className="mi-search-control">
                <OutlinedInput
                  className="mi-input mi-search-input"
                  placeholder="Search by title or path..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon className="mi-search-icon" />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div className="mi-table-wrapper">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Titulli</TableCell>
                    <TableCell>Path</TableCell>
                    <TableCell>Ikona</TableCell>
                    <TableCell>Numri rendor</TableCell>
                    <TableCell>Global</TableCell>
                    <TableCell>Statusi</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visibleMenuRows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} className="mi-empty-cell">
                        <p className="mi-empty-text">Nuk ka asnje menu</p>
                      </TableCell>
                    </TableRow>
                  ) : (
                    visibleMenuRows.map((item) => (
                      <TableRow
                        key={item.MenuID}
                        className={`mi-tree-row ${
                          Number(item._depth || 0) === 0
                            ? "mi-tree-row--parent"
                            : "mi-tree-row--child"
                        }`}
                      >
                        <TableCell className="mi-cell-title">
                          <div
                            className="mi-tree-title-wrap"
                            style={{ paddingLeft: `${Math.max(0, Number(item._depth || 0)) * 18}px` }}
                          >
                            {(item._children || []).length > 0 ? (
                              <IconButton
                                size="small"
                                className="mi-tree-toggle"
                                onClick={() => toggleRowExpand(item.MenuID)}
                              >
                                {expandedMenus[item.MenuID] ? (
                                  <KeyboardArrowDownIcon fontSize="small" />
                                ) : (
                                  <KeyboardArrowRightIcon fontSize="small" />
                                )}
                              </IconButton>
                            ) : (
                              <span className="mi-tree-spacer" />
                            )}

                            <span className="mi-tree-title-text">{item.Title}</span>
                          </div>
                        </TableCell>
                        <TableCell className="mi-cell-path">
                          {item.Path}
                        </TableCell>
                        <TableCell>{item.Icon || "-"}</TableCell>
                        <TableCell>{item.OrderNo}</TableCell>
                        <TableCell>
                          <div className="mi-status-badges">
                            {item.IsGlobal ? (
                              <span className="status-badge status-badge--active">
                                Global
                              </span>
                            ) : (
                              <span className="status-badge status-badge--inactive">
                                Jo-Global
                              </span>
                            )}
                          </div>
                        </TableCell>

                        <TableCell>
                          <div className="mi-status-badges">
                            {item.IsActive ? (
                              <span className="status-badge status-badge--active">
                                Active
                              </span>
                            ) : (
                              <span className="status-badge status-badge--inactive">
                                Inactive
                              </span>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right">
                          <div className="mi-actions">
                            {/* <Button
                              variant="text"
                              size="small"
                              onClick={() =>
                                history.push(
                                  buildMenuItemsUrl({
                                    mode: "view",
                                    id: item.MenuID,
                                  })
                                )
                              }
                            >
                              <VisibilityIcon className="mi-icon" />
                            </Button> */}
                            <Button
                              variant="text"
                              size="small"
                              onClick={() =>
                                history.push(
                                  buildMenuItemsUrl({
                                    mode: "edit",
                                    id: item.MenuID,
                                  })
                                )
                              }
                            >
                              <EditIcon className="mi-icon" />
                            </Button>
                            <Button
                              variant="text"
                              size="small"
                              onClick={() => openDeleteDialog(item)}
                            >
                              <DeleteIcon className="mi-icon" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>

      <Dialog open={deleteDialogOpen} onClose={closeDeleteDialog}>
        <DialogTitle>Delete Menu Item</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete "{itemToDelete?.Title}"? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog}>Cancel</Button>
          <Button
            onClick={confirmDelete}
            className="mi-btn-danger"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
